// Helpers for separating a token's actual word from surrounding punctuation.
// e.g. "da?" -> { lead:"", core:"da", trail:"?" }; "da" is the word, "?" is
// punctuation that should display but never be treated as a timed/lookupable word.

export function splitToken(text) {
  const t = text || '';
  const lead = (t.match(/^\p{P}+/u) || [''])[0];
  const rest = t.slice(lead.length);
  const trail = (rest.match(/\p{P}+$/u) || [''])[0];
  const core = rest.slice(0, rest.length - trail.length);
  return { lead, core, trail };
}

// The bare word, stripped of leading/trailing punctuation. Used for vocab
// status, gloss, and dictionary lookups so "da" and "da?" are the same word.
export function cleanWord(text) {
  return (text || '').replace(/^\p{P}+|\p{P}+$/gu, '');
}
